// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// import API from '../../contract_details/btoken.json';
import * as ABI from '../../contract_details/btoken.json';
import LABI from '../../contract_details/Lending.json';
import BABI from '../../contract_details/Borrow.json';
import IERC20 from '../../upgradeable-contract/artifacts/contracts/tokens/TestToken.sol/TestToken.json';
import BToken from '../../contract_details/BToken1.json';
import RouterArtifact from '../../upgradeable-contract/artifacts/contracts/BruRouter.sol/BruRouter.json';
import PoolArtifact from '../../upgradeable-contract/artifacts/contracts/core/BruPool.sol/BruPool.json';
import TreasuryArtifact from '../../upgradeable-contract/artifacts/contracts/core/AssetTreasury.sol/AssetTreasury.json';
import PoolTokenArtifact from '../../upgradeable-contract/artifacts/contracts/tokens/PoolToken.sol/PoolToken.json';
import FactoryArtifact from '../../upgradeable-contract/artifacts/contracts/core/BruFactory.sol/BruFactory.json';
import TokenArtifact from '../../upgradeable-contract/artifacts/contracts/tokens/TestToken.sol/TestToken.json';

export const environment = {
  production: false,
  // baseURL: 'http://localhost:5056',
  // BASE_URI: 'https://uat-backend.whrrl.in',
  // BASE_URI: 'http://localhost:8002',
  baseURL: 'https://prodbackend.bru.finance',
  // baseURL: 'https://betabackend.bru.finance',
  // baseURL: 'http://localhost:5056',
  WHRRLBaseUrl: 'https://backend.whrrl.in',
  // BASE_URI: 'https://uat-backend.whrrl.in',
  // BASE_URI: 'http://localhost:8002',
  // baseURL: 'https://prodbackend.bru.finance',
  cryptoComparePriceURL: 'https://min-api.cryptocompare.com/data/price',
  googleClientId:
    '602242376186-qsqghv1gcni9j1bvpu3f5fshafho7dco.apps.googleusercontent.com',
  facebookClientId: '258151686411272',
  // RouterAddress : '0xa3c552c713A68BA2E7e8838fb4C2D13cABDBfD03',
  RouterABI: RouterArtifact.abi,
  PoolABI: PoolArtifact.abi,
  TreasuryABI: TreasuryArtifact.abi,
  TokenABI: TokenArtifact.abi,
  PoolTokenABI: PoolTokenArtifact.abi,
  // Polygon Addresses
  // TokenAddress: '0xb5b6Ab9CAB4D452a0B8cA480f094A2124Af6679f',
  // factoryAddress: '0xE708FFf8A321bCF46BFCE07B07F82C6FBD2E873a',
  // RouterAddress: '0x48F718E942C35d361b3270AE19035F1228b68E62',

  // new address
  // TokenAddress: '0x7ef8E99980Da5bcEDcF7C10f41E55f759F6A174B',
  // factoryAddress: '0x77c7E3905c21177Be97956c6620567596492C497',
  // RouterAddress: '0x03Fb741bFDc7588794D3eCaB869b3537AdeA8394',
  // new address
  // usdcTokenAddress: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
  TokenAddress: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
  // factoryAddress: '0xED79b078dFeF6618A1eA456720Fa4CD3c4E43209',
  // RouterAddress: '0xe8BF2801a3e457FE141407a3b39F47fDE83B376f',
  // // TokenAddress:"0x5B9042a9a3207b9dbED0D4E52384890048922760",
  // factoryAddress:'0x8c5233519393124F0DF5023afCA090B150af7eA8',
  factoryABI: FactoryArtifact.abi,
  ABI,
  lendingContractAddress: '0x6FFa0968A6A2851f76b8294E99C223E715829B44',
  // tokenContractAddress: '0xF4D75B801a5213dbBD8211BB2adf760816dd3e0c',
  bTokenAddress: '0x25B32f1bCe3842Ae3D8e7DDf344e6e9498f01A7c',
  borrowContractAddress: '0xd73C1AeE2326B02669b64813725EA5FfEFa0adb2',
  lendingABI: LABI,
  iercABI: IERC20.abi,
  bTokenABI: BToken,
  borrowABI: BABI,

  tokenContractAddress: '0xF16007DE4145ec6152e4c8c467A984b647fd8908',
  usdcTokenAddress: '0x956EaD2636dfD58D7215E6A415eD4e3E21430fDd',
  factoryAddress: '0x4756516A799Efde91B8A09845547F1dD17Bcf4D0',
  RouterAddress: '0x34c4388EB6e5a856eE22a5A612f8fbffD6d70e78',
  PoolAddress: '0x61154B0C73717DF854B20a56a53BdBfa3B37a810',
};

// {
//      "TOKEN_ADDRESS": "0xdAD510AcEEcfD4beBCF3F55e8b96f1043C0EaA5E",
//      "FACTORY_ADDRESS": "0x46d6003EF5d28B6CD414328cb4B809c9b53F52cc",
//      "ROUTER_ADDRESS": "0xC1709088bca13d4cD774432A2451dc6006FAC48e"
// }

// {
//      "TOKEN_ADDRESS": "0x58373acDf01b97D0CD4e63576ca62D09F4B44994",
//      "FACTORY_ADDRESS": "0xA6Ac1ffe08dC13Feb3212974FD109396b1137A43",
//      "ROUTER_ADDRESS": "0x555e00a736cd3696A53D606D82E26341F63901d8"
// }
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
